import { Heading } from '@flixbus/honeycomb-react';
import React from 'react';

export const Loading = () => {
  return <Heading size={4}>Authentication in progress...</Heading>;
};
